/**
 * Human-readable message from axios error or API body { message, details, error }.
 * @param {unknown} err
 * @param {string} [fallback]
 * @returns {string}
 */
export function formatApiError(err, fallback = 'Request failed') {
  if (!err || typeof err !== 'object') {
    return fallback;
  }
  const d = err.response?.data;
  if (!d || typeof d !== 'object') {
    return typeof err.message === 'string' && err.message.trim() ? err.message : fallback;
  }
  const parts = [];
  if (typeof d.message === 'string' && d.message.trim()) {
    parts.push(d.message.trim());
  }
  if (Array.isArray(d.details)) {
    const detailStr = d.details.filter(Boolean).map(String).join(' ').trim();
    if (detailStr) parts.push(detailStr);
  } else if (typeof d.details === 'string' && d.details.trim()) {
    parts.push(d.details.trim());
  }
  if (typeof d.error === 'string' && d.error.trim() && d.error !== d.message) {
    parts.push(d.error.trim());
  }
  if (typeof d.suggestion === 'string' && d.suggestion.trim()) {
    parts.push(`Recommendation: ${d.suggestion.trim()}`);
  }
  const merged = parts.filter(Boolean).join(' — ');
  return merged || (typeof err.message === 'string' ? err.message : fallback);
}
